export default __webpack_public_path__ + "static/media/discord.e5c4709e.svg";